import React, { useEffect } from 'react';
import { CheckIcon, WarningIcon, DeleteIcon } from '../UI/Icons';
import './Notification.css';

interface NotificationProps {
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  onClose: () => void;
  duration?: number;
}

const Notification: React.FC<NotificationProps> = ({
  message,
  type,
  onClose,
  duration = 3000
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckIcon size={20} />;
      case 'error':
        return <WarningIcon size={20} />;
      case 'warning':
        return <WarningIcon size={20} />;
      case 'info':
        return <CheckIcon size={20} />;
      default:
        return <CheckIcon size={20} />;
    }
  };

  return (
    <div className={`notification notification-${type}`}>
      <div className="notification-icon">{getIcon()}</div>
      <div className="notification-message">{message}</div>
      <button className="notification-close" onClick={onClose}>
        <DeleteIcon size={16} />
      </button>
    </div>
  );
};

export default Notification;
